import { render, staticRenderFns } from "./yzqmxFormModal.vue?vue&type=template&id=94b40066&scoped=true&"
import script from "./yzqmxFormModal.vue?vue&type=script&lang=js&"
export * from "./yzqmxFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b40066",
  null
  
)

export default component.exports